<template>
    <div class="modal fade" ref="contestWinnersModal" data-keyboard="false" data-backdrop="static" id="contest-winners-modal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <a type="button" class="modal-close-btn" data-dismiss="modal">
                        <img src="/images/global/close-icon.svg">
                    </a>
                    <div class="modal-title text-center w-100 font-weight-bold">Congratulations to the Best in Show Agents!</div>
                </div>
                <div class="modal-body">
                    <div class="pt-4 px-3 px-xl-6">
                        <div id="contest-winners" class="table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th style="min-width: 200px">Name</th>
                                        <th style="min-width: 200px">Channel</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="winners">
                                        <tr v-for="winner in winners">
                                            <td style="width: 200px">{{ winner.agent_name }}</td>
                                            <td style="width: 200px">{{ winner.channel }}</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        winners: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    mounted() {
        $(this.$refs.contestWinnersModal).modal('show');
    },
}
</script>
